<div class="list-item">
  <tui-badged-content [style.--tui-radius.%]="50">
    <tui-badge-notification
      *ngIf="getColor() as color"
      tuiSlot="top"
      [size]="'s'"
      [style.background-color]="color"
    ></tui-badge-notification>

    <app-photo
      [size]="'m'"
      [rounded]="true"
      [type]="'photo'"
      [id]="data?.photoId"
      [text]="data?.titleText || ''"
      [showPreview]="false"
    ></app-photo>
  </tui-badged-content>

  <div class="list-item__info">
    <div class="header">
      <span class="list-item__text text_size-xs text_color-03">
        {{ data?.dateStart | stringToDate | datePeriod: (data?.dateEnd | stringToDate) : false }}
      </span>

      <app-badge
        *ngIf="badgeOptions"
        [size]="badgeOptions.size"
        [color]="badgeOptions.color"
        [value]="badgeOptions.value"
      ></app-badge>
    </div>

    <div class="list-item__title">
      <span class="list-item__text text_size-m text_color-01 text_line-2">
        {{ data?.titleText }}
      </span>
    </div>

    <span *ngIf="data?.descriptionText" class="list-item__text text_size-xs text_color-03 text_truncate text_line-1">
      {{ data?.descriptionText }}
    </span>
  </div>
</div>
